module.exports = __webpack_public_path__ + "img/35_BF13_pants_water_filter.288bd46c.jpg";